import { fetchActiveIntegrationsRequest, fetchAllCampaignsRequest } from 'actions/campaigns';
import platform from 'constants/platform';
import { GlobalState } from 'reducers';
import { createSelector } from 'reselect';
import type { MCampaign, NormalizedResource, Selector } from 'types';

export const getFetchAllCampaignsLoading: Selector<boolean> = (state) =>
  state.campaign.loading.includes(fetchAllCampaignsRequest.toString());

export const getCampaignFilterItems: Selector<NormalizedResource<MCampaign>> = (state) =>
  state.campaign.filterItems;

export const getCampaignsList: Selector<MCampaign[]> = createSelector(
  [(state: GlobalState): GlobalState['campaign']['campaigns'] => state.campaign.campaigns],
  (campaigns) => {
    const campaignItems = Object.keys(campaigns).map((key) => {
      const campaign = {
        ...campaigns[key],
        platforms: [] as string[],
      };

      type Key = keyof typeof platform;
      Object.keys(platform).forEach((platformKey) => {
        if (campaign[platformKey as Key]) {
          campaign.platforms.push(platform[platformKey as Key]);
        }
      });

      return campaign;
    });

    return campaignItems;
  }
);

export const getActiveIntegrationsLoading: Selector<boolean> = (state) =>
  state.campaign.loading.includes(fetchActiveIntegrationsRequest.toString());
